import { Badge } from '@monksflow/monks-ui';
import type { BriefTemplateLevelBadgeProps } from './BriefTemplateLevelBadge.types';
import {
  briefTemplateLevelLabel,
  briefTemplateLevelVariant,
} from './BriefTemplateLevelBadge.utils';

export function BriefTemplateLevelBadge({ level }: BriefTemplateLevelBadgeProps) {
  return (
    <Badge variant={briefTemplateLevelVariant(level)} roundness="full">
      {briefTemplateLevelLabel(level)}
    </Badge>
  );
}
